import RestrictedUserRoute from "discourse/routes/restricted-user";
export default class PreferencesSecurity extends RestrictedUserRoute {}